export const defaultToastProps = {
    isClosable: true,
    duration: 5000
};